import React from 'react';
import { cn } from '../../lib/utils';
interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  container?: boolean;
  background?: 'white' | 'gray' | 'primary' | 'accent';
}
export function Section({
  children,
  className,
  container = true,
  background = 'white',
  ...props
}: SectionProps) {
  const backgrounds = {
    white: 'bg-white',
    gray: 'bg-gray-50',
    primary: 'bg-primary-700 text-white',
    accent: 'bg-accent-50'
  };
  return <section className={cn('py-16 md:py-24', backgrounds[background], className)} {...props} data-id="element-116">
      {container ? <div className="container mx-auto px-4 md:px-6" data-id="element-117">{children}</div> : children}
    </section>;
}